import {
  GetLoginPathToOrganizationParams,
  getLoginPathToOrganization,
} from '@/app/api/auth/[auth0]/getLoginPathToOrganization';
import { CurrentUserData } from '@/app/api/user/current/types';
import { UserOrganizationData } from '@/app/api/user/organization/types';
import { UserOrganizationsData } from '@/app/api/user/organizations/types';
import { UserSubscriptionsResponse } from '@/app/api/user/subscriptions/types';
import { AUTH0_PATH, LOGIN_HINT_PARAM } from '@/constants/pages';
import { Subscription, UserCompanySchema } from '@/generated/prisma';
import { ROUTE, axiosInstance } from './axiosInstance';

export const user = {
  current: async ({ stripeSubs }: { stripeSubs?: boolean } = {}) => {
    const { data } = await axiosInstance.get<CurrentUserData>(ROUTE.USER.CURRENT, { params: { stripeSubs } });
    return data;
  },
  organizations: async () => {
    const { data } = await axiosInstance.get<UserOrganizationsData>(ROUTE.USER.ORGANIZATIONS);
    return data;
  },
  organization: async (orgId: string) => {
    const { data } = await axiosInstance.get<UserOrganizationData>(ROUTE.USER.ORGANIZATION, { params: { orgId } });
    return data;
  },
  getLoginPathToOrganization: ({ org_id, redirectUrl }: GetLoginPathToOrganizationParams) => {
    return getLoginPathToOrganization({ org_id, redirectUrl });
  },
  getLoginPath: ({ loginHint, orgId }: { loginHint?: string; orgId?: string }) => {
    const loginUrl = new URL(AUTH0_PATH.LOGIN, window.location.origin);
    if (loginHint) {
      loginUrl.searchParams.append(LOGIN_HINT_PARAM, loginHint);
    }
    if (orgId) {
      loginUrl.searchParams.append('organization', orgId);
    }
    return loginUrl.toString();
  },
  getSubscriptions: async () => {
    const { data } = await axiosInstance.get<UserSubscriptionsResponse>(ROUTE.USER.SUBSCRIPTIONS);
    return data;
  },
  getSubscriptionsAvailableProductIds: async () => {
    const { data } = await axiosInstance.get<string[]>(ROUTE.USER.SUBSCRIPTIONS_AVAILABLE_PRODUCT_IDS);
    return data;
  },
  refreshToken: () => axiosInstance.get(ROUTE.USER.REFRESH_TOKEN),
  updateSession: () => axiosInstance.get(ROUTE.USER.UPDATE_SESSION),
  revalidateSession: () => axiosInstance.get(ROUTE.USER.REVALIDATE_SESSION),
  getMatchedCompany: async () => {
    const { data } = await axiosInstance.get<{ company: UserCompanySchema | null }>(ROUTE.USER.USER_COMPANY);
    return data.company;
  },
};
